module.exports = {
      id: "glyph:heart-usage",
      viewBox: "0 0 20 18",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#glyph:heart-usage",
      toString: function () {
        return this.url;
      }
    }